export default {
  'pages.layouts.userLayout.title':
    'Ant Design 是西湖區最具影響力的 Web 設計規範',
  'pages.login.accountLogin.tab': '賬戶密碼登錄',
  'pages.login.accountLogin.errorMessage':
    '錯誤的用戶名和密碼(admin/ant.design)',
  'pages.login.failure': '登錄失敗，請重試！',
  'pages.login.success': '登錄成功！',
  'pages.login.username.placeholder': '用戶名: admin or user',
  'pages.login.username.required': '用戶名是必填項！',
  'pages.login.password.placeholder': '密碼: ant.design',
  'pages.login.password.required': '密碼是必填項！',
  'pages.login.phoneLogin.tab': '手機號登錄',
  'pages.login.phoneLogin.errorMessage': '驗證碼錯誤',
  'pages.login.phoneNumber.placeholder': '請輸入手機號！',
  'pages.login.phoneNumber.required': '手機號是必填項！',
  'pages.login.phoneNumber.invalid': '不合法的手機號！',
  'pages.login.captcha.placeholder': '請輸入驗證碼！',
  'pages.login.captcha.required': '驗證碼是必填項！',
  'pages.login.phoneLogin.getVerificationCode': '獲取驗證碼',
  'pages.getCaptchaSecondText': '秒後重新獲取',
  'pages.login.rememberMe': '自動登錄',
  'pages.login.forgotPassword': '忘記密碼 ?',
  'pages.login.submit': '登錄',
  'pages.login.loginWith': '其他登錄方式 :',
  'pages.login.registerAccount': '註冊賬戶',
  'pages.login.welcome': '歡迎使用智能視頻處理平台',
  'pages.welcome.link': '歡迎使用',
  'pages.welcome.alertMessage': '更快更強的重型組件，已經發布。',
  'pages.404.subTitle': '抱歉，您訪問的頁面不存在。',
  'pages.404.buttonText': '返回首頁',
  'pages.admin.subPage.title': '這個頁面只有 admin 權限才能查看',
  'pages.admin.subPage.alertMessage':
    'umi ui 現已發佈，歡迎使用 npm run ui 啓動體驗。',
  'pages.searchTable.createForm.newRule': '新建規則',
  'pages.searchTable.updateForm.ruleConfig': '規則配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '規則名稱',
  'pages.searchTable.updateForm.ruleName.nameRules': '請輸入規則名稱！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '規則描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '請輸入至少五個字符',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '請輸入至少五個字符的規則描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置規則屬性',
  'pages.searchTable.updateForm.object': '監控對象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '規則模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '規則類型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '設定調度週期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '開始時間',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '請選擇開始時間！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '規則名稱爲必填項',
  'pages.searchTable.titleCallNo': '服務調用次數',
  'pages.searchTable.titleStatus': '狀態',
  'pages.searchTable.nameStatus.default': '關閉',
  'pages.searchTable.nameStatus.running': '運行中',
  'pages.searchTable.nameStatus.online': '已上線',
  'pages.searchTable.nameStatus.abnormal': '異常',
  'pages.searchTable.titleUpdatedAt': '上次調度時間',
  'pages.searchTable.exception': '請輸入異常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '訂閱警報',
  'pages.searchTable.title': '查詢表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已選擇',
  'pages.searchTable.item': '項',
  'pages.searchTable.totalServiceCalls': '服務調用次數總計',
  'pages.searchTable.tenThousand': '萬',
  'pages.searchTable.batchDeletion': '批量刪除',
  'pages.searchTable.batchApproval': '批量審批',
  'pages.employee.management': '員工管理',
  'pages.employee.new': '新增員工',
  'pages.employee.detail': '詳情',
  'pages.employee.edit': '編輯',
  'pages.employee.delete': '刪除',
  'pages.employee.deleteConfirm': '確定刪除此項嗎？',
  'pages.employee.okText': '確定',
  'pages.employee.cancelText': '取消',
  'pages.employee.deleteSuccess': '刪除成功',
  'pages.employee.deleteFailed': '刪除失敗',
  'pages.employee.fetchDetailFailed': '獲取詳情失敗',
  'pages.employee.createTitle': '創建員工',
  'pages.employee.editTitle': '編輯員工',
  'pages.employee.detailTitle': '員工詳情',
  'pages.employee.updatedSuccessfully': '更新成功',
  'pages.employee.createdSuccessfully': '創建成功',
  'pages.employee.updateFailed': '更新失敗，請重試',
  'pages.employee.createFailed': '創建失敗，請重試',
  'pages.employee.employeeNumber': '員工編號',
  'pages.employee.name': '姓名',
  'pages.employee.organization': '組織',
  'pages.employee.department': '部門',
  'pages.employee.position': '職位',
  'pages.employee.role': '角色',
  'pages.employee.status': '狀態',
  'pages.employee.active': '啟用',
  'pages.employee.inactive': '禁用',
  'pages.employee.remark': '備註',
  'pages.employee.namePlaceholder': '請輸入姓名!',
  'pages.employee.employeeId': '員工ID',
  'pages.employee.employeeIdPlaceholder': '請輸入員工ID',
  'pages.employee.selectDepartment': '請選擇部門',
  'pages.employee.selectPosition': '請選擇職位',
  'pages.employee.operation': '操作',
  'pages.employee.deleteConfirmContent': '確定刪除此員工嗎？',

  // 設備管理模組國際化
  'pages.device.management': '設備管理',
  'pages.device.gateway': '網關',
  'pages.device.terminal': '終端',
  'pages.device.noData': '暫無設備數據',
  'pages.device.noDataDescription': '當前沒有任何設備數據，請先創建網關設備',
  'pages.device.createGateway': '新建網關',
  'pages.device.refresh': '刷新',
  'pages.device.viewDetails': '查看詳情',
  'pages.device.online': '在線',
  'pages.device.offline': '離線',
  'pages.device.hasChild': '有子設備',
  'pages.device.noChild': '無子設備',
};
